import _createForOfIteratorHelper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function t(t, n, e) {
  if (t && t.length) {
    var _n = _slicedToArray(n, 2),
        _o = _n[0],
        _s = _n[1],
        _r = Math.PI / 180 * e,
        _i = Math.cos(_r),
        _a = Math.sin(_r);

    t.forEach(function (t) {
      var _t = _slicedToArray(t, 2),
          n = _t[0],
          e = _t[1];

      t[0] = (n - _o) * _i - (e - _s) * _a + _o, t[1] = (n - _o) * _a + (e - _s) * _i + _s;
    });
  }
}

function n(t) {
  var n = t[0],
      e = t[1];
  return Math.sqrt(Math.pow(n[0] - e[0], 2) + Math.pow(n[1] - e[1], 2));
}

function e(t, n, e, o) {
  var s = n[1] - t[1],
      r = t[0] - n[0],
      i = s * t[0] + r * t[1],
      a = o[1] - e[1],
      c = e[0] - o[0],
      h = a * e[0] + c * e[1],
      u = s * c - a * r;
  return u ? [(c * i - r * h) / u, (s * h - a * i) / u] : null;
}

function o(t, n, e) {
  var o = t.length;
  if (o < 3) return !1;
  var a = [Number.MAX_SAFE_INTEGER, e],
      c = [n, e];
  var h = 0;

  for (var _n2 = 0; _n2 < o; _n2++) {
    var _e = t[_n2],
        _u = t[(_n2 + 1) % o];

    if (i(_e, _u, c, a)) {
      if (0 === r(_e, c, _u)) return s(_e, c, _u);
      h++;
    }
  }

  return h % 2 == 1;
}

function s(t, n, e) {
  return n[0] <= Math.max(t[0], e[0]) && n[0] >= Math.min(t[0], e[0]) && n[1] <= Math.max(t[1], e[1]) && n[1] >= Math.min(t[1], e[1]);
}

function r(t, n, e) {
  var o = (n[1] - t[1]) * (e[0] - n[0]) - (n[0] - t[0]) * (e[1] - n[1]);
  return 0 === o ? 0 : o > 0 ? 1 : 2;
}

function i(t, n, e, o) {
  var i = r(t, n, e),
      a = r(t, n, o),
      c = r(e, o, t),
      h = r(e, o, n);
  return i !== a && c !== h || !(0 !== i || !s(t, e, n)) || !(0 !== a || !s(t, o, n)) || !(0 !== c || !s(e, t, o)) || !(0 !== h || !s(e, n, o));
}

function a(n, e) {
  var o = [0, 0],
      s = Math.round(e.hachureAngle + 90);
  s && t(n, o, s);

  var r = function (t, n) {
    var e = _toConsumableArray(t);

    e[0].join(",") !== e[e.length - 1].join(",") && e.push([e[0][0], e[0][1]]);
    var o = [];

    if (e && e.length > 2) {
      var _ret = function () {
        var t = n.hachureGap;
        t < 0 && (t = 4 * n.strokeWidth), t = Math.max(t, .1);
        var s = [];

        for (var _t2 = 0; _t2 < e.length - 1; _t2++) {
          var _n3 = e[_t2],
              _o2 = e[_t2 + 1];

          if (_n3[1] !== _o2[1]) {
            var _t3 = Math.min(_n3[1], _o2[1]);

            s.push({
              ymin: _t3,
              ymax: Math.max(_n3[1], _o2[1]),
              x: _t3 === _n3[1] ? _n3[0] : _o2[0],
              islope: (_o2[0] - _n3[0]) / (_o2[1] - _n3[1])
            });
          }
        }

        if (s.sort(function (t, n) {
          return t.ymin < n.ymin ? -1 : t.ymin > n.ymin ? 1 : t.x < n.x ? -1 : t.x > n.x ? 1 : t.ymax === n.ymax ? 0 : (t.ymax - n.ymax) / Math.abs(t.ymax - n.ymax);
        }), !s.length) return {
          v: o
        };
        var r = [],
            i = s[0].ymin;

        for (; r.length || s.length;) {
          if (s.length) {
            var _t4 = -1;

            for (var _n4 = 0; _n4 < s.length && !(s[_n4].ymin > i); _n4++) {
              _t4 = _n4;
            }

            s.splice(0, _t4 + 1).forEach(function (t) {
              r.push({
                s: i,
                edge: t
              });
            });
          }

          if (r = r.filter(function (t) {
            return !(t.edge.ymax <= i);
          }), r.sort(function (t, n) {
            return t.edge.x === n.edge.x ? 0 : (t.edge.x - n.edge.x) / Math.abs(t.edge.x - n.edge.x);
          }), r.length > 1) for (var _t5 = 0; _t5 < r.length; _t5 += 2) {
            var _n5 = _t5 + 1;

            if (_n5 >= r.length) break;
            var _e2 = r[_t5].edge,
                _s2 = r[_n5].edge;
            o.push([[Math.round(_e2.x), i], [Math.round(_s2.x), i]]);
          }
          i += t, r.forEach(function (n) {
            n.edge.x = n.edge.x + t * n.edge.islope;
          });
        }
      }();

      if (typeof _ret === "object") return _ret.v;
    }

    return o;
  }(n, e);

  return s && (t(n, o, -s), function (n, e, o) {
    var s = [];
    n.forEach(function (t) {
      return s.push.apply(s, _toConsumableArray(t));
    }), t(s, e, o);
  }(r, o, -s)), r;
}

var c = /*#__PURE__*/function (_ref) {
  _inherits(c, _ref);

  var _super = _createSuper(c);

  function c() {
    _classCallCheck(this, c);

    return _super.apply(this, arguments);
  }

  _createClass(c, [{
    key: "fillPolygon",
    value: function fillPolygon(t, n) {
      return this._fillPolygon(t, n, !0);
    }
  }]);

  return c;
}( /*#__PURE__*/function () {
  function _class(t) {
    _classCallCheck(this, _class);

    this.helper = t;
  }

  _createClass(_class, [{
    key: "fillPolygon",
    value: function fillPolygon(t, n) {
      return this._fillPolygon(t, n);
    }
  }, {
    key: "_fillPolygon",
    value: function _fillPolygon(t, n) {
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = a(t, n);

      if (e) {
        var _n6 = this.connectingLines(t, o);

        o = o.concat(_n6);
      }

      return {
        type: "fillSketch",
        ops: this.renderLines(o, n)
      };
    }
  }, {
    key: "renderLines",
    value: function renderLines(t, n) {
      var e = [];

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o3 = _step.value;
          e.push.apply(e, _toConsumableArray(this.helper.doubleLineOps(_o3[0][0], _o3[0][1], _o3[1][0], _o3[1][1], n)));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return e;
    }
  }, {
    key: "connectingLines",
    value: function connectingLines(t, e) {
      var o = [];
      if (e.length > 1) for (var _s3 = 1; _s3 < e.length; _s3++) {
        var _r2 = e[_s3 - 1];
        if (n(_r2) < 3) continue;
        var _i2 = [e[_s3][0], _r2[1]];

        if (n(_i2) > 3) {
          var _n7 = this.splitOnIntersections(t, _i2);

          o.push.apply(o, _toConsumableArray(_n7));
        }
      }
      return o;
    }
  }, {
    key: "midPointInPolygon",
    value: function midPointInPolygon(t, n) {
      return o(t, (n[0][0] + n[1][0]) / 2, (n[0][1] + n[1][1]) / 2);
    }
  }, {
    key: "splitOnIntersections",
    value: function splitOnIntersections(t, s) {
      var r = Math.max(5, .1 * n(s)),
          a = [];

      for (var _o4 = 0; _o4 < t.length; _o4++) {
        var _c = t[_o4],
            _h = t[(_o4 + 1) % t.length];

        if (i.apply(void 0, [_c, _h].concat(_toConsumableArray(s)))) {
          var _t6 = e(_c, _h, s[0], s[1]);

          if (_t6) {
            var _e3 = n([_t6, s[0]]),
                _o5 = n([_t6, s[1]]);

            _e3 > r && _o5 > r && a.push({
              point: _t6,
              distance: _e3
            });
          }
        }
      }

      if (a.length > 1) {
        var _n8 = a.sort(function (t, n) {
          return t.distance - n.distance;
        }).map(function (t) {
          return t.point;
        });

        if (o.apply(void 0, [t].concat(_toConsumableArray(s[0]))) || _n8.shift(), o.apply(void 0, [t].concat(_toConsumableArray(s[1]))) || _n8.pop(), _n8.length <= 1) return this.midPointInPolygon(t, s) ? [s] : [];

        var _e4 = [s[0]].concat(_toConsumableArray(_n8), [s[1]]),
            _r3 = [];

        for (var _n9 = 0; _n9 < _e4.length - 1; _n9 += 2) {
          var _o6 = [_e4[_n9], _e4[_n9 + 1]];
          this.midPointInPolygon(t, _o6) && _r3.push(_o6);
        }

        return _r3;
      }

      return this.midPointInPolygon(t, s) ? [s] : [];
    }
  }]);

  return _class;
}());

var h = /*#__PURE__*/function () {
  function h(t) {
    _classCallCheck(this, h);

    this.seed = t;
  }

  _createClass(h, [{
    key: "next",
    value: function next() {
      return this.seed ? (Math.pow(2, 31) - 1 & (this.seed = Math.imul(48271, this.seed))) / Math.pow(2, 31) : Math.random();
    }
  }]);

  return h;
}();

function u(t, n, e, o, s) {
  return {
    type: "path",
    ops: M(t, n, e, o, s)
  };
}

function l(t, n) {
  return function (t, n, e) {
    var o = (t || []).length;

    if (o > 2) {
      var _s4 = [];

      for (var _n10 = 0; _n10 < o - 1; _n10++) {
        _s4.push.apply(_s4, _toConsumableArray(M(t[_n10][0], t[_n10][1], t[_n10 + 1][0], t[_n10 + 1][1], e)));
      }

      return n && _s4.push.apply(_s4, _toConsumableArray(M(t[o - 1][0], t[o - 1][1], t[0][0], t[0][1], e))), {
        type: "path",
        ops: _s4
      };
    }

    return 2 === o ? u(t[0][0], t[0][1], t[1][0], t[1][1], e) : {
      type: "path",
      ops: []
    };
  }(t, !0, n);
}

function f(t, n, e, o, s) {
  return function (t, n, e, o) {
    var _b = b(o.increment, t, n, o.rx, o.ry, 1, o.increment * g(.1, g(.4, 1, e), e), e),
        _b2 = _slicedToArray(_b, 2),
        s = _b2[0],
        r = _b2[1];

    var i = y(s, null, e);

    if (!e.disableMultiStroke) {
      var _b3 = b(o.increment, t, n, o.rx, o.ry, 1.5, 0, e),
          _b4 = _slicedToArray(_b3, 1),
          _s5 = _b4[0],
          _r4 = y(_s5, null, e);

      i = i.concat(_r4);
    }

    return {
      estimatedPoints: r,
      opset: {
        type: "path",
        ops: i
      }
    };
  }(t, n, s, p(e, o, s)).opset;
}

function p(t, n, e) {
  var o = Math.sqrt(2 * Math.PI * Math.sqrt((Math.pow(t / 2, 2) + Math.pow(n / 2, 2)) / 2)),
      s = Math.max(e.curveStepCount, e.curveStepCount / Math.sqrt(200) * o),
      r = 2 * Math.PI / s;
  var i = Math.abs(t / 2),
      a = Math.abs(n / 2);
  var c = 1 - e.curveFitting;
  return i += m(i * c, e), a += m(a * c, e), {
    increment: r,
    rx: i,
    ry: a
  };
}

function d(t) {
  return t.randomizer || (t.randomizer = new h(t.seed || 0)), t.randomizer.next();
}

function g(t, n, e) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return e.roughness * o * (d(e) * (n - t) + t);
}

function m(t, n) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return g(-t, t, n, e);
}

function M(t, n, e, o, s) {
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  var i = r ? s.disableMultiStrokeFill : s.disableMultiStroke,
      a = x(t, n, e, o, s, !0, !1);
  if (i) return a;
  var c = x(t, n, e, o, s, !0, !0);
  return a.concat(c);
}

function x(t, n, e, o, s, r, i) {
  var a = Math.pow(t - e, 2) + Math.pow(n - o, 2),
      c = Math.sqrt(a);
  var h = 1;
  h = c < 200 ? 1 : c > 500 ? .4 : -.0016668 * c + 1.233334;
  var u = s.maxRandomnessOffset || 0;
  u * u * 100 > a && (u = c / 10);
  var l = u / 2,
      f = .2 + .2 * d(s);
  var p = s.bowing * s.maxRandomnessOffset * (o - n) / 200,
      g = s.bowing * s.maxRandomnessOffset * (t - e) / 200;
  p = m(p, s, h), g = m(g, s, h);

  var M = [],
      x = function x() {
    return m(l, s, h);
  },
      y = function y() {
    return m(u, s, h);
  };

  return r && (i ? M.push({
    op: "move",
    data: [t + x(), n + x()]
  }) : M.push({
    op: "move",
    data: [t + m(u, s, h), n + m(u, s, h)]
  })), i ? M.push({
    op: "bcurveTo",
    data: [p + t + (e - t) * f + x(), g + n + (o - n) * f + x(), p + t + 2 * (e - t) * f + x(), g + n + 2 * (o - n) * f + x(), e + x(), o + x()]
  }) : M.push({
    op: "bcurveTo",
    data: [p + t + (e - t) * f + y(), g + n + (o - n) * f + y(), p + t + 2 * (e - t) * f + y(), g + n + 2 * (o - n) * f + y(), e + y(), o + y()]
  }), M;
}

function y(t, n, e) {
  var o = t.length,
      s = [];

  if (o > 3) {
    var _r5 = [],
        _i3 = 1 - e.curveTightness;

    s.push({
      op: "move",
      data: [t[1][0], t[1][1]]
    });

    for (var _n11 = 1; _n11 + 2 < o; _n11++) {
      var _e5 = t[_n11];
      _r5[0] = [_e5[0], _e5[1]], _r5[1] = [_e5[0] + (_i3 * t[_n11 + 1][0] - _i3 * t[_n11 - 1][0]) / 6, _e5[1] + (_i3 * t[_n11 + 1][1] - _i3 * t[_n11 - 1][1]) / 6], _r5[2] = [t[_n11 + 1][0] + (_i3 * t[_n11][0] - _i3 * t[_n11 + 2][0]) / 6, t[_n11 + 1][1] + (_i3 * t[_n11][1] - _i3 * t[_n11 + 2][1]) / 6], _r5[3] = [t[_n11 + 1][0], t[_n11 + 1][1]], s.push({
        op: "bcurveTo",
        data: [_r5[1][0], _r5[1][1], _r5[2][0], _r5[2][1], _r5[3][0], _r5[3][1]]
      });
    }

    if (n && 2 === n.length) {
      var _t7 = e.maxRandomnessOffset;
      s.push({
        op: "lineTo",
        data: [n[0] + m(_t7, e), n[1] + m(_t7, e)]
      });
    }
  } else 3 === o ? (s.push({
    op: "move",
    data: [t[1][0], t[1][1]]
  }), s.push({
    op: "bcurveTo",
    data: [t[1][0], t[1][1], t[2][0], t[2][1], t[2][0], t[2][1]]
  })) : 2 === o && s.push.apply(s, _toConsumableArray(M(t[0][0], t[0][1], t[1][0], t[1][1], e)));

  return s;
}

function b(t, n, e, o, s, r, i, a) {
  var c = [],
      h = [],
      u = m(.5, a) - Math.PI / 2;
  h.push([m(r, a) + n + .9 * o * Math.cos(u - t), m(r, a) + e + .9 * s * Math.sin(u - t)]);

  for (var _i4 = u; _i4 < 2 * Math.PI + u - .01; _i4 += t) {
    var _t8 = [m(r, a) + n + o * Math.cos(_i4), m(r, a) + e + s * Math.sin(_i4)];
    c.push(_t8), h.push(_t8);
  }

  return h.push([m(r, a) + n + o * Math.cos(u + 2 * Math.PI + .5 * i), m(r, a) + e + s * Math.sin(u + 2 * Math.PI + .5 * i)]), h.push([m(r, a) + n + .98 * o * Math.cos(u + i), m(r, a) + e + .98 * s * Math.sin(u + i)]), h.push([m(r, a) + n + .9 * o * Math.cos(u + .5 * i), m(r, a) + e + .9 * s * Math.sin(u + .5 * i)]), [h, c];
}

var P = {
  randOffset: function randOffset(t, n) {
    return t;
  },
  randOffsetWithRange: function randOffsetWithRange(t, n, e) {
    return (t + n) / 2;
  },
  ellipse: function ellipse(t, n, e, o, s) {
    return f(t, n, e, o, s);
  },
  doubleLineOps: function doubleLineOps(t, n, e, o, s) {
    return function (t, n, e, o, s) {
      return M(t, n, e, o, s, !0);
    }(t, n, e, o, s);
  }
};

function v(t) {
  return {
    maxRandomnessOffset: 2,
    roughness: 1,
    bowing: .85,
    stroke: "#000",
    strokeWidth: 1.5,
    curveTightness: 0,
    curveFitting: .95,
    curveStepCount: 9,
    fillStyle: "hachure",
    fillWeight: 3.5,
    hachureAngle: -41,
    hachureGap: 5,
    dashOffset: -1,
    dashGap: -1,
    zigzagOffset: 0,
    combineNestedSvgPaths: !1,
    disableMultiStroke: !1,
    disableMultiStrokeFill: !1,
    seed: t
  };
}

function w(t, n) {
  var e = "";

  var _iterator2 = _createForOfIteratorHelper(t.ops),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _o7 = _step2.value;
      var _t9 = _o7.data;

      switch (_o7.op) {
        case "move":
          if (n && e) break;
          e += "M".concat(_t9[0], " ").concat(_t9[1], " ");
          break;

        case "bcurveTo":
          e += "C".concat(_t9[0], " ").concat(_t9[1], ", ").concat(_t9[2], " ").concat(_t9[3], ", ").concat(_t9[4], " ").concat(_t9[5], " ");
          break;

        case "lineTo":
          e += "L".concat(_t9[0], " ").concat(_t9[1], " ");
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return e.trim();
}

function I(t, n) {
  var e = document.createElementNS("http://www.w3.org/2000/svg", t);
  if (n) for (var _t10 in n) {
    e.setAttributeNS(null, _t10, n[_t10]);
  }
  return e;
}

function S(t, n) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var o = I("path", {
    d: w(t, e)
  });
  return n && n.appendChild(o), o;
}

function k(t, n, e, o, s, r) {
  return S(function (t, n, e, o, s) {
    return l([[t, n], [t + e, n], [t + e, n + o], [t, n + o]], s);
  }(n + 2, e + 2, o - 4, s - 4, v(r)), t);
}

function O(t, n, e, o, s, r) {
  return S(u(n, e, o, s, v(r)), t);
}

function T(t, n, e) {
  return S(l(n, v(e)), t, !0);
}

function $(t, n, e, o, s, r) {
  return S(f(n, e, o = Math.max(o > 10 ? o - 4 : o - 1, 1), s = Math.max(s > 10 ? s - 4 : s - 1, 1), v(r)), t);
}

function E(t, n) {
  return S(new c(P).fillPolygon(t, v(n)), null);
}

function L(t, n, e, o, s) {
  var r = p(e, o, v(s)),
      i = [];
  var a = 0;

  for (; a <= 2 * Math.PI;) {
    i.push([t + r.rx * Math.cos(a), n + r.ry * Math.sin(a)]), a += r.increment;
  }

  return E(i, s);
}

export { $ as ellipse, L as hachureEllipseFill, E as hachureFill, O as line, T as polygon, k as rectangle, I as svgNode };